import { IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const HeaderContainerStyled = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  backgroundColor: '#000E1C',
});

export const ButtonsContainerStyled = styled('div')({
  display: 'flex',
  gap: 32,
});

export const IconsContainerStyled = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  '& button': {
    backgroundColor: '#171D2D',
    width: 50,
    height: 50,
  },
});

export const BTNLogoutStyled = styled(IconButton)(({ theme }) => ({
  display: 'flex',
  gap: 16,
  color: theme.palette.global.white,
  '& h4': {
    marginLeft: 8,
  },
}));

export const ConfigureStyled = styled('div')({
  border: '1px solid #999',
  maxWidth: 250,
  right: 270,
  position: 'absolute',
  backgroundColor: '#000E1C',
  '& h5': {
    margin: '5px 5px',
  },
  '& p': {
    margin: '5px 5px',
    color: '#fff',
    fontWeight: 'normal',
    fontSize: 14,
    cursor: 'pointer',
    '&:hover': {
      color: '#999',
    },
  },
});
